import React from 'react'
import Select from '../../Components/Autocompelte/Select'
import CustomInput from '../../Components/Input/CustomInput'
import DatePicker from '../../Components/Input/DatePicker'

const FleetRegister = ({ fleetRegister, setFleetRegister, errors }) => {
  const handleChange = (name, value) => {
    setFleetRegister((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  const handleDateChange = (date) => {
    setFleetRegister((prevState) => ({
      ...prevState,
      birthDate: date,
    }))
  }

  return (
    <div className="mt-7">
      <div className="w-full text-start text-stone-500 text-sm md:text-base font-bold">
        Register Fleet
      </div>
      <div className="mt-2">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2 text-start">
          <div>
            <CustomInput
              placeholderValue={'First Name'}
              labelValue={'First Name'}
              required
              name="firstName"
              onChange={(value) => handleChange('firstName', value)}
              value={fleetRegister.firstName}
            />
            {errors.firstName && (
              <small className="text-red-500">{errors.firstName}</small>
            )}
          </div>
          <div>
            <CustomInput
              placeholderValue={'Last Name'}
              labelValue={'Last Name'}
              required
              name="lastName"
              onChange={(value) => handleChange('lastName', value)}
              value={fleetRegister.lastName}
            />
            {errors.lastName && (
              <small className="text-red-500">{errors.lastName}</small>
            )}
          </div>
          <div>
            <CustomInput
              formatMobileNumber
              placeholderValue={'Mobile Number'}
              type={'tel'}
              maxlength={'10'}
              labelValue={'Mobile Number'}
              required
              name="mobileNumber"
              onChange={(value) => handleChange('mobileNumber', value)}
              value={fleetRegister.mobileNumber}
            />
            {errors.mobileNumber && (
              <small className="text-red-500">{errors.mobileNumber}</small>
            )}
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2 text-start">
          <div>
            <CustomInput
              formatMobileNumber
              placeholderValue={'Emergency Number'}
              labelValue={'Emergency Number'}
              type={'tel'}
              maxlength={'10'}
              name="emergencyNumber"
              onChange={(value) => handleChange('emergencyNumber', value)}
              value={fleetRegister.emergencyNumber}
            />
            {errors.emergencyNumber && (
              <small className="text-red-500">{errors.emergencyNumber}</small>
            )}
          </div>
          <div>
            <DatePicker
              labelValue="Birth Date"
              selected={fleetRegister.birthDate}
              onChange={handleDateChange}
            />
            {errors.birthDate && (
              <small className="text-red-500">{errors.birthDate}</small>
            )}
          </div>
          <div>
            <CustomInput
              placeholderValue={'Address'}
              labelValue={'Address'}
              required
              name="address"
              onChange={(value) => handleChange('address', value)}
              value={fleetRegister.address}
            />
            {errors.address && (
              <small className="text-red-500">{errors.address}</small>
            )}
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2 text-start">
          <div>
            <CustomInput
              placeholderValue={'City'}
              labelValue={'City'}
              required
              name="city"
              onChange={(value) => {
                setFleetRegister((prevState) => ({
                  ...prevState,
                  city: value,
                }))
              }}
              value={fleetRegister?.city}
            />
            {errors.city && (
              <small className="text-red-500">{errors.city}</small>
            )}
          </div>
          <div>
            <CustomInput
              placeholderValue={'State'}
              labelValue={'State'}
              r1equired
              name="state"
              onChange={(value) => {
                setFleetRegister((prevState) => ({
                  ...prevState,
                  state: value,
                }))
              }}
              value={fleetRegister?.state}
            />
            {errors.state && (
              <small className="text-red-500">{errors.state}</small>
            )}
          </div>
          <div>
            <Select
              selected={{
                label: fleetRegister?.operationCity,
                value: fleetRegister?.operationCity,
              }}
              labelValue={'Select Operation City'}
              placeholderValue={'Operation City'}
              options={[
                { label: 'Pune', value: 'Pune' },
                { label: 'Mumbai', value: 'Mumbai' },
                { label: 'Bengaluru', value: 'Bengaluru' },
              ]}
              onSelect={(value) => {
                setFleetRegister((prevState) => ({
                  ...prevState,
                  operationCity: value?.value,
                }))
              }}
            />
            {errors.operationCity && (
              <small className="text-red-500">{errors.operationCity}</small>
            )}
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2 text-start">
          <div>
            <CustomInput
              placeholderValue={'Email'}
              type={'email'}
              labelValue={'Email'}
              required
              name="email"
              onChange={(value) => {
                setFleetRegister((prevState) => ({
                  ...prevState,
                  email: value,
                }))
              }}
              value={fleetRegister?.email}
            />
            {errors.email && (
              <small className="text-red-500">{errors.email}</small>
            )}
          </div>
          <div>
            <CustomInput
              placeholderValue={'Password'}
              labelValue={'Password'}
              inputtype="password"
              required
              name="password"
              type="password"
              onChange={(value) => {
                setFleetRegister((prevState) => ({
                  ...prevState,
                  password: value,
                }))
              }}
              value={fleetRegister?.password}
            />
            {errors.password && (
              <small className="text-red-500">{errors.password}</small>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default FleetRegister
